import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivateChild, Router, RouterStateSnapshot} from '@angular/router';
import {AccountService} from './account.service';

@Injectable({
  providedIn: 'root'
})

export class AccountInfoGuard implements CanActivateChild {
  constructor(private router: Router, private accountService: AccountService) {
  }

  canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
    let user = this.accountService.getUserData();  
    // the readonly inspection page can be seen by i-register users that don't have user-detail info 
    if(state.url.startsWith("/inspections/view/")) {
      return true;
    }

    if(user && !user.hasUserDetail){
      this.router.navigateByUrl('/account/edit');
    }

    return !(user && !user.hasUserDetail);
  }
}
